<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Spare Parts &nbsp;
          <add-button
            link="/planned-maintenance/spare-parts/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Spare Parts</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportspare_parts.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="spare_parts_excel"
                    :fields="excel_fields"
                    worksheet="Spare Parts"
                    name="Spare Part.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Spare Name</th>
                    <th>Make</th>
                    <th>Part Number</th>
                    <th>Draw Number</th>
                    <th>Critical</th>
                    <th>ROB</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="spare_parts.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(spare_part, at) in spare_parts"
                    :key="`spare_part${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ spare_part.vessel.name }}</td>
                    <td>{{ spare_part.spare_name }}</td>
                    <td>{{ spare_part.make }}</td>
                    <td>{{ spare_part.part_number }}</td>
                    <td>{{ spare_part.draw_number }}</td>
                    <td>
                      {{ spare_part.is_critical == true ? "Yas" : "No" }}
                    </td>
                    <td>{{ spare_part.rob }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/spare-parts/${spare_part.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(spare_part.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "spare_part",
  data() {
    return {
      spare_parts: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      spare_parts_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        Category: "category_id",
        "Spare Name": "spare_name",
        "Spare Code": "spare_code",
        "SFI Code": "sfi_code",
        Make: "make",
        "Part Number": "part_number",
        "Draw Number": "draw_number",
        "Model Number": "model_number",
        "Serial Number": "serial_number",
        Measure: "measure_id",
        "Expiry Date": "expiry_date",
        "Location on Board": "location_on_board",
        "Is Critical": "is_critical",
        "Is SOPEP Item": "is_sopep_item",
        Remarks: "remarks",
        Attchment: "attachment",
        "Average Price": "average_price",
        "Latest Price": "latest_price",
        "Current Total Price": "current_total_price",
        "Supplier Name": "supplier_name",
        "PO Number": "po_number",
        "Min Alarm Level": "min_alarm_level",
        "Max Alarm Level": "max_alarm_level",
        "Consumed Quality": "consumed_quantity",
        ROB: "rob",
        "New Items": "new_items",
        "Is Tracked Item": "is_tracked_item",
      },
      Exportspare_parts: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let spare_parts = await axios.get(
        `/spare_parts?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.spare_parts = spare_parts.data.data;
      this.count = spare_parts.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let spare_parts = await axios.get(
        `/spare_parts?search=${this.searchData}`
      );
      this.spare_parts = spare_parts.data.data;
      this.count = spare_parts.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Spare Part Data";
      this.spare_parts_excel = [];
      let Exportspare_parts = [];
      Exportspare_parts = await axios.get(`/spare_parts`);
      this.Exportspare_parts = Exportspare_parts.data.data;
      let sr_no = 1;
      this.Exportspare_parts.forEach((spare_part) => {
        this.spare_parts_excel.push({
          sr_no: sr_no,
          vessel: spare_part.vessel.name ? spare_part.vessel.name : "",
          spare_name: spare_part.spare_name ? spare_part.spare_name : "",
          spare_code: spare_part.spare_code ? spare_part.spare_code : "",
          sfi_code: spare_part.sfi_code ? spare_part.sfi_code : "",
          make: spare_part.make ? spare_part.make : "",
          part_number: spare_part.part_number ? spare_part.part_number : "",
          draw_number: spare_part.draw_number ? spare_part.draw_number : "",
          model_number: spare_part.model_number ? spare_part.model_number : "",
          serial_number: spare_part.serial_number
            ? spare_part.serial_number
            : "",
          measure_id: spare_part.measure_id ? spare_part.measure_id : "",
          expiry_date: spare_part.expiry_date ? spare_part.expiry_date : "",
          location_on_board: spare_part.location_on_board.name
            ? spare_part.location_on_board.name
            : "",
          is_critical: spare_part.is_critical
            ? spare_part.is_critical == true
              ? "Yes"
              : "No"
            : "",
          is_sopep_item: spare_part.is_sopep_item
            ? spare_part.is_sopep_item == true
              ? "Yes"
              : "No"
            : "",
          remarks: spare_part.remarks ? spare_part.remarks : "",
          attachment: spare_part.attachment ? spare_part.attachment : "",
          average_price: spare_part.average_price
            ? spare_part.average_price
            : "",
          latest_price: spare_part.latest_price ? spare_part.latest_price : "",
          current_total_price: spare_part.current_total_price
            ? spare_part.current_total_price
            : "",
          supplier_name: spare_part.supplier_name
            ? spare_part.supplier_name
            : "",
          po_number: spare_part.po_number ? spare_part.po_number : "",
          min_alarm_level: spare_part.min_alarm_level
            ? spare_part.min_alarm_level
            : "",
          max_alarm_level: spare_part.max_alarm_level
            ? spare_part.max_alarm_level
            : "",
          consumed_quantity: spare_part.consumed_quantity
            ? spare_part.consumed_quantity
            : "",
          rob: spare_part.rob ? spare_part.rob : "",
          new_items: spare_part.new_items ? spare_part.new_items : "",
          is_tracked_item: spare_part.is_tracked_item
            ? spare_part.is_tracked_item == true
              ? "Yes"
              : "No"
            : "",
          measure: spare_part.measure.name ? spare_part.measure.name : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=spare_parts`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
